export const defaultStock = (item) => {
    if (typeof item?.stock === 'number') {
        return item.stock;
    }
    return 0;
};

export const itemWithOverride = (item, override) => {
    if (!item) {
        return item;
    }
    if (!override) {
        const stock = defaultStock(item);
        const images = item.images?.length ? item.images : (item.image ? [item.image] : []);
        return {
            ...item,
            edition: item.format === 'sticker' ? '' : item.edition,
            stock,
            soldOut: stock <= 0,
            bestSeller: item.badge === 'Best Seller',
            images,
            image: images[0] || item.image,
        };
    }
    const next = { ...item };
    if (override.price != null) {
        next.price = Number(override.price);
    }
    if (override.edition != null) {
        next.edition = item.format === 'sticker' ? '' : override.edition;
    }
    if (item.format === 'sticker') {
        next.edition = '';
    }
    if (override.stock != null) {
        next.stock = Number(override.stock);
    } else {
        next.stock = defaultStock(next);
    }
    next.soldOut = next.stock <= 0;
    if (typeof override.bestSeller === 'boolean') {
        next.bestSeller = override.bestSeller;
        next.badge = override.bestSeller ? 'Best Seller' : undefined;
    } else {
        next.bestSeller = item.badge === 'Best Seller';
    }
    if (override.shopOrder != null && override.shopOrder !== '') {
        next.shopOrder = Number(override.shopOrder);
    }
    next.images = next.images?.length ? next.images : (next.image ? [next.image] : []);
    if (next.images[0]) {
        next.image = next.images[0];
    }
    return next;
};

export const mergeShopItems = (items, overrides = {}) =>
    items.map((item) => itemWithOverride(item, overrides[item.id]));

export const withAvailability = (items, reserved = {}) =>
    items.map((item) => {
        const held = Number(reserved[item.id] || 0);
        const available = Math.max(0, Number(item.stock || 0) - held);
        return {
            ...item,
            available,
            soldOut: available <= 0,
        };
    });

export const mergeCatalog = (baseItems, customItems = [], overrides = {}, reserved = {}, hiddenIds = []) => {
    const hidden = new Set(hiddenIds);
    const combined = [
        ...baseItems,
        ...customItems.filter((item) => item?.custom && item?.id && item?.image),
    ];
    return withAvailability(mergeShopItems(combined, overrides), reserved)
        .map((item) => ({ ...item, hidden: hidden.has(item.id) }))
        .sort((a, b) => (a.shopOrder || 0) - (b.shopOrder || 0));
};

export const visibleCatalog = (items) => items.filter((item) => !item.hidden);
